import React, { useState } from "react";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Form, FormGroup, Label, Input, Alert } from "reactstrap";
import Loading from "../../components/Loading";
import { createProduct } from "../../utils/apiService";

const CreateProductComponent = () => {
  const { brandId } = useParams();
  const history = useHistory();
  const { getAccessTokenSilently } = useAuth0();

  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const token = await getAccessTokenSilently().catch(() => null);
      await createProduct({ name }, parseInt(brandId, 10), token);
      history.push(`/brands/${brandId}/products`);
    } catch (err) {
      setError(err?.message || "Failed to create product");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="mb-3">
        <Button color="link" className="p-0 me-2" onClick={() => history.push('/brands')}>Brands</Button>
        <span className="text-muted"> &gt; </span>
        <Button color="link" className="p-0 mx-2" onClick={() => history.push(`/brands/${brandId}/products`)}>Products</Button>
        <span className="text-muted"> &gt; Create Product</span>
      </div>
      <Card>
        <CardHeader><h1 className="mb-0">Add Product</h1></CardHeader>
        <CardBody>
          {error && <Alert color="danger">{error}</Alert>}
          <Form onSubmit={onSubmit}>
            <FormGroup>
              <Label for="productName">Product Name</Label>
              <Input
                id="productName"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </FormGroup>
            <div className="d-flex">
              <Button color="secondary" className="me-2" type="button" onClick={() => history.push(`/brands/${brandId}/products`)} disabled={submitting}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={submitting}>
                {submitting ? 'Creating...' : 'Create Product'}
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default withAuthenticationRequired(CreateProductComponent, {
  onRedirecting: () => <Loading />,
});
